import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RequirementService } from '@app/services/requirement.service';
import { setRestoreAdminClientTab } from '@app/admin/client/admin-client-tab-state.util';

@Component({
  selector: 'app-portal-client-messages-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './portal-client-messages-modal.component.html',
  styleUrls: ['./portal-client-messages-modal.component.scss']
})
export class PortalClientMessagesModalComponent implements OnInit {
  @Input() requirementId: number;

  comments: any[] = [];
  newComment = '';
  commentFile: File | null = null;
  loading = true;
  sending = false;
  contactEmailWarning: string | null = null;
  contactEmailAdminPath: string | null = null;
  contactEmailAdminLinkLabel = 'Contrapartes';

  constructor(
    public activeModal: NgbActiveModal,
    private requirements: RequirementService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadContactEmailStatus();
    this.loadComments();
  }

  private loadContactEmailStatus(): void {
    if (!this.requirementId) {
      return;
    }
    this.requirements.getPortalContactEmailStatus(this.requirementId).subscribe({
      next: (resp: any) => {
        const data = resp?.result ?? resp;
        this.contactEmailWarning = data?.warningMessage || null;
        this.contactEmailAdminPath = data?.adminContactPath || '/admin/client';
        this.contactEmailAdminLinkLabel = data?.adminContactLinkLabel || 'Contrapartes';
      },
      error: () => {
        this.contactEmailWarning = null;
        this.contactEmailAdminPath = null;
      }
    });
  }

  get commentsList(): any[] {
    return Array.isArray(this.comments) ? this.comments : [];
  }

  getCommentAttachments(c: any): any[] {
    if (!c) return [];
    if (Array.isArray(c.attachments)) return c.attachments;
    return [];
  }

  loadComments(): void {
    if (!this.requirementId) return;
    this.loading = true;
    this.requirements.getPortalclientComments(this.requirementId).subscribe({
      next: (resp: any) => {
        const data = resp?.result ?? resp;
        this.comments = Array.isArray(data) ? data : [];
        this.requirements.markPortalclientCommentsRead(this.requirementId).subscribe();
        this.loading = false;
      },
      error: () => {
        this.comments = [];
        this.loading = false;
      }
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.commentFile = input.files?.length ? input.files[0] : null;
  }

  clearFile(): void {
    this.commentFile = null;
    const el = document.getElementById('modal-comment-file-input') as HTMLInputElement;
    if (el) el.value = '';
  }

  sendComment(): void {
    const note = this.newComment.trim();
    if ((!note && !this.commentFile) || !this.requirementId || this.sending) return;
    this.sending = true;
    this.requirements.addPortalclientComment(this.requirementId, note || '(archivo adjunto)', this.commentFile ?? undefined).subscribe({
      next: () => {
        this.newComment = '';
        this.clearFile();
        this.sending = false;
        this.loadComments();
      },
      error: () => { this.sending = false; }
    });
  }

  formatDate(d: string | Date): string {
    if (!d) return '-';
    const date = new Date(d);
    return date.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' ' +
      date.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
  }

  getCommentAuthor(c: { fromClient?: boolean; author?: string }): string {
    if (c?.fromClient || c?.author === 'Cliente') {
      return 'Contraparte';
    }
    return c?.author || 'Usuario';
  }

  goToCounterpartiesAdmin(): void {
    const path = this.contactEmailAdminPath || '/admin/client';
    this.activeModal.dismiss();
    const urlTree = this.router.parseUrl(path);
    const typeCode = urlTree.queryParams['typeCode'];
    if (typeCode) {
      setRestoreAdminClientTab(`type-${String(typeCode)}`);
    } else if (path.includes('/cliente/')) {
      setRestoreAdminClientTab('legacy-clientes');
    }
    void this.router.navigateByUrl(urlTree);
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
